import { render } from "./AdminSearchTrips.vue?vue&type=template&id=7878ccef&scoped=true"
import script from "./AdminSearchTrips.vue?vue&type=script&lang=js"
export * from "./AdminSearchTrips.vue?vue&type=script&lang=js"

import "./AdminSearchTrips.vue?vue&type=style&index=0&id=7878ccef&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7878ccef"]])

export default __exports__